import { ApplicationResponse } from "../../lib-api/models/ApplicationResponse";
import { ApplicationRequest } from "../../lib-api";

//export enum PaymentMethod {
//    PBS = 1,
//    GIRO = 2
//}

export enum Step {
    Main = 1,
    Amount = 2,
    Contact = 3,
    Marital = 4,
    LoanReason = 5,
    Coappliant = 6,
    Cars = 7,
    Payment = 8,
    Consent = 9,
    Callback = 10,
    Children = 11,
    RKI = 12,
    Dwelling = 13,
    AmountLanding = 14,
    CoappliantContact = 100,
    AmountAlt = 101
}

export enum FormStep {
    Start,
    Contact,
    Other,
    Payment,
    Approve
}

export type ApplicationState = {
    currentStep: number;

    data: ApplicationRequest;
    application: {
        id: string;
        sending: boolean;
        lastStep: Step;
        error: Response;
        data?: ApplicationResponse;
    };
};

